<template>
	<div class="shop-container">
		<img v-if="advertObj.length" :src="advertObj[0].img" alt="" width="100%" class="ad-top" @click="swiperClick(advertObj[0])" />
		<div class="nav">
			<router-link to="/">首页</router-link>
			<span>></span>
			<a href="javascript:;">全部结果</a>
			<template v-if="$route.query.name">
				<span>></span>
				<span v-if="$route.query.id">分类:</span>
				<span>{{ $route.query.name }}</span>
			</template>
		</div>
		<div class="bgw nodata" v-if="noDataIsShow">
			没有找到与“
			<span class="search-name">{{ clickText || $route.query.name }}</span>
			”相关的商品
		</div>
		<div class="container bgw" v-show="true">
			<div class="filter-box">
				<div class="filter-list-wrap" v-if="timeStatus.length > 0">
					<div class="filter-list-head">状态:</div>
					<div class="filter-list">
						<div
							class="filter-item"
							v-for="(item, index) in filterClassComputed(timeStatus, 'class')"
							:key="index"
							@click="selectCat(item.id)"
							:class="selectedCatId == item.id ? 'active' : ''"
						>
							<span>{{ item.name }}</span>
						</div>
					</div>
					<div class="more" @click="showMoreClass = !showMoreClass" v-if="timeStatus.length > 6">
						{{ showMoreClass ? '收起' : '更多' }}
						<i class="icon iconfont iconxjt" :class="{ top: showMoreClass }"></i>
					</div>
				</div>
				<div class="filter-list-wrap brand-wrap" v-if="filter.length > 0" @mouseleave="handleCategoryLeave">
					<div class="filter-list-head">分类:</div>
					<div class="filter-list">
						<div class="filter-item" :class="{ active: catAll }" @click="selectBrandAll()" @mouseenter="handleCategoryHover(null)"><span>全部</span></div>

						<div
							class="filter-item"
							v-for="(item, index) in filterClassComputed(filter, 'brand')"
							:key="index"
							:class="(selectedBrandId == item.id || prevId == item.id || (hoverCat && hoverCat.id == item.id)) ? 'active' : ''"
							@mouseenter="handleCategoryHover(item)"
						>
							<span @click="selectBrand(item)">{{ item.name }}</span>
						</div>
					</div>
					<div class="more" v-if="filter.length > 9" @click="showMoreBrand = !showMoreBrand">
						{{ showMoreBrand ? '收起' : '更多' }}
						<i class="icon iconfont iconxjt" :class="{ top: showMoreBrand }"></i>
					</div>

					<!-- 二级分类弹层 -->
					<transition name="fade">
						<div
							class="child-content"
							v-if="displayedChildList && displayedChildList.length"
							@mouseenter="handleChildEnter"
							@mouseleave="handleChildLeave"
						>
							<div class="span-wrap">
								<span
									v-for="(child, idx) in displayedChildList"
									:key="idx"
									:class="selectedBrandId == child.id ? 'active' : ''"
									@click="selectBrand(child, displayedParentId)"
								>
									{{ child.name }}
								</span>
							</div>
						</div>
					</transition>
				</div>
				<div class="sort-box">
					<span class="sort-title">排序:</span>
					<ul class="filter-nav">
						<li :class="{ active: searchOptions.order.key == 'sort' }">
							<a href="javascript:;" @click="comprehensive">综合</a>
						</li>
						<li :class="{ active: searchOptions.order.key == 'start_price' }">
							<a href="javascript:;" @click="priceSort">
								起拍价
								<i
									class="icon iconfont"
									:class="searchOptions.order.key == 'start_price' && searchOptions.order.sort == 'asc' ? 'iconpriceup' : 'iconpricedown'"
								></i>
							</a>
						</li>
						<li :class="{ active: searchOptions.order.key == 'latest_price' }">
							<a href="javascript:;" @click="lastPriceSort">
								当前价
								<i
									class="icon iconfont"
									:class="searchOptions.order.key == 'latest_price' && searchOptions.order.sort == 'asc' ? 'iconpriceup' : 'iconpricedown'"
								></i>
							</a>
						</li>
						<li :class="{ active: searchOptions.order.key == 'watch_num' }">
							<a href="javascript:;" @click="salesVolume">
								拍品热度
								<i class="icon iconfont" :class="searchOptions.order.key == 'watch_num' && searchOptions.order.sort == 'asc' ? 'iconpriceup' : 'iconpricedown'"></i>
							</a>
						</li>
					</ul>
				</div>

				<div class="filter-checkbox" v-if="meStatus.length > 0">
					<span>我的:</span>
					<el-checkbox-group v-model="checkMeList"  @change="updateCheckMeList($event)">
						<el-checkbox :label="item.id" v-for="(item, i) in meStatus" :key="i">{{ item.name }}</el-checkbox>
					</el-checkbox-group>
				</div>
				<div class="filter-checkbox" v-if="labelList.length > 0">
					<span>筛选:</span>
					<el-checkbox-group v-model="checkList">
						<el-checkbox :label="item.id" v-for="(item, i) in labelList" :key="i">{{ item.name }}</el-checkbox>
					</el-checkbox-group>
				</div>
			</div>
		</div>
		<div v-loading="loadingShow">
			<auctionCom :list="goodsList" />
		</div>
		<template v-if="goodsList.length > 0">
			<Pagination :totalPage="totalPage" :limit="searchOptions.limit" @changePage="handleCurrentChange"></Pagination>
		</template>

		<ScrollToTop></ScrollToTop>
	</div>
</template>

<script>
import { showLoading, hideLoading } from '../utils/loading';
import AuctionCom from '@/components/layout/AuctionCom.vue';

import Pagination from '@/components/common/Pagination.vue';
import ScrollToTop from '@/components/common/ScrollToTop.vue';

import { deepCopy } from '@/utils';
import { goodsStyle } from '@/utils';
import { itemClick } from '@/utils/mixins.js';

export default {
	name: 'SearchResult',
	components: { Pagination, AuctionCom, ScrollToTop },
	props: {},
	mixins: [itemClick],
	data() {
		return {
			showFilter: true,
			showMoreClass: false,
			showMoreBrand: false,
			checkList: [],
			checkMeList: [],
			catList: [], //分类
			brandList: [], //品牌
			labelList: [], //筛选标签
			goodsList: [],
			totalPage: 0,
			searchOptions: {
				where: {},
				limit: 12,
				page: 1,
				order: {
					key: 'sort',
					sort: 'asc' //默认综合排序
				}
			},
			noDataIsShow: false,
			loadingShow: false,
			firstLoad: true, //是否初次加载
			selectedCatId: '', //选择的分类ID
			selectedBrandId: '', //选择的品牌ID
			selectedlabelId: '', //选择的筛选ID
			goodsStyleCom: 'Auction',
			filter: [],
			hoverCat: null,
			hoverTimer: null,
			enterTimer: null,
			timeStatus: [
				{ name: '全部', id: 0 },
				{ name: '即将开始', id: 1 },
				{ name: '正在进行', id: 2 },
				{ name: '已经结束', id: 3 },
				{ name: '竞拍失败', id: 4 }
				// {name: '失败', id: 4},
			],
			meStatus: [
				{ name: '我的收藏', id: 0, isSelect: false },
				{ name: '我的竞拍', id: 1, isSelect: false }
			],
			prevId: '',
			clickText: '', // 点击了文案
			catAll: '',
			goodsStyle: Number, // 商品列表排列方式  1：多个一行 2：一个一行
			advertObj: []
		};
	},
	watch: {
		$route(to, from) {
			if (from.name == 'detail') return;
			if (this.$route.name == 'auctionlist') {
				let query = this.$route.query;
				//console.log(query);
				this.initData(query);
			}
		}
	},

	computed: {
		filterClassComputed() {
			return (list, type) => {
				if (list.length < 10) {
					return list;
				}
				if (type == 'class') {
					if (this.showMoreClass) {
						return list;
					}
				}
				if (type == 'brand') {
					if (this.showMoreBrand) {
						return list;
					}
				}
				return list.slice(0, 9);
			};
		},
		// 当前需要展示的二级分类列表（仅在鼠标悬停在含子分类的一级分类时展示）
		displayedChildList() {
			if (this.hoverCat && this.hoverCat.child && this.hoverCat.child.length) {
				return this.hoverCat.child;
			}
			return [];
		},
		// 当前展示的二级分类对应的父级ID
		displayedParentId() {
			if (this.hoverCat) {
				return this.hoverCat.id;
			}
			return '';
		}
	},
	methods: {
		initData(query) {
			this.firstLoad = true;
			this.selectedCatId = '';
			this.selectedBrandId = '';
			this.selectedlabelId = '';
			this.prevId = '';
			this.hoverCat = null;
			let sd = this.searchOptions;
			this.searchOptions = Object.assign(sd, { where: {} });
			this.handleParamsData(query);
			this.syncParentId();
		},
		//分类悬浮 (防划过误触 Hover Intent)
		handleCategoryHover(item) {
			if (this.hoverTimer) {
				clearTimeout(this.hoverTimer);
				this.hoverTimer = null;
			}
			if (this.enterTimer) {
				clearTimeout(this.enterTimer);
				this.enterTimer = null;
			}

			// 如果悬停在已激活的分类上，保持即可
			if (item && this.hoverCat && this.hoverCat.id === item.id) {
				return;
			}

			// 核心防误触逻辑：
			// 如果当前已经展开了二级分类，说明用户可能正在把鼠标斜向移向二级分类，途中快速划过了相邻一级分类；
			// 此时增加 160ms 的防划过延时，如果鼠标只是快速滑过，不会切换或销毁当前的二级分类。
			// 如果当前还没有展开任何二级分类，则快速响应（50ms）。
			let delay = (this.hoverCat && this.hoverCat.child && this.hoverCat.child.length) ? 160 : 50;

			this.enterTimer = setTimeout(() => {
				if (item && item.child && item.child.length) {
					this.hoverCat = item;
				} else {
					this.hoverCat = null;
				}
				this.enterTimer = null;
			}, delay);
		},
		handleCategoryLeave() {
			if (this.enterTimer) {
				clearTimeout(this.enterTimer);
				this.enterTimer = null;
			}
			if (this.hoverTimer) {
				clearTimeout(this.hoverTimer);
			}
			this.hoverTimer = setTimeout(() => {
				this.hoverCat = null;
			}, 600);
		},
		handleChildEnter() {
			// 鼠标成功进入二级分类弹层，取消一切待切换/待隐藏的定时器，锁定当前二级分类
			if (this.enterTimer) {
				clearTimeout(this.enterTimer);
				this.enterTimer = null;
			}
			if (this.hoverTimer) {
				clearTimeout(this.hoverTimer);
				this.hoverTimer = null;
			}
		},
		handleChildLeave() {
			if (this.enterTimer) {
				clearTimeout(this.enterTimer);
				this.enterTimer = null;
			}
			if (this.hoverTimer) {
				clearTimeout(this.hoverTimer);
			}
			this.hoverTimer = setTimeout(() => {
				this.hoverCat = null;
			}, 600);
		},
		syncParentId() {
			if (!this.selectedBrandId || !this.filter || !this.filter.length) return;
			for (let cat of this.filter) {
				if (cat.id == this.selectedBrandId) {
					this.prevId = '';
					return;
				}
				if (cat.child && cat.child.length) {
					let found = cat.child.find((c) => c.id == this.selectedBrandId);
					if (found) {
						this.prevId = cat.id;
						return;
					}
				}
			}
		},
		//搜索状态
		selectCat(id) {
			let data = {
				page: 1,
				auction_status: id
				// where: {
				//   cat_id: id
				// }
			};
			this.selectedCatId = id;
			this.setSearchOptions(data, true);
			this.getGoodsList();
		},
		//搜索品牌

		selectBrandAll() {
			this.catAll = 'all';
			this.selectedBrandId = '';
			this.prevId = '';
			if (this.hoverTimer) {
				clearTimeout(this.hoverTimer);
				this.hoverTimer = null;
			}
			this.hoverCat = null;

			let data = {
				page: 1,
				where: {
					cat_id: ''
				}
			};
			this.setSearchOptions(data, true);
			this.getGoodsList();
		},
		selectBrand(val, prev) {
			this.catAll = '';
			let id = val.id;
			this.clickText = val.name;
			this.prevId = prev || '';
			// 点击选择后立即隐藏二级分类弹层
			if (this.hoverTimer) {
				clearTimeout(this.hoverTimer);
				this.hoverTimer = null;
			}
			this.hoverCat = null;

			let data = {
				page: 1,
				where: {
					// brand_id: id
					cat_id: id
				}
			};
			
			this.selectedBrandId = id;
			this.setSearchOptions(data, true);
			this.getGoodsList();
		},
		//更新选中我的
		updateCheckMeList(event){
			let data = {}
			if( this.checkMeList.includes(0)){
				data.only_collect = 1;
			}else{
				delete this.searchOptions.only_collect;
			}
			if( this.checkMeList.includes(1)){
				data.only_offer = 1;
			}else{
				delete this.searchOptions.only_offer;
			}
			
			this.setSearchOptions(data, true);
			this.getGoodsList();
		},
		//筛选条件参数处理
		conditions() {
			let data = this.searchOptions;
			var newData = {};
			newData = deepCopy(newData, data);
			//把data里的where换成json
			if (data.where) {
				newData.where = JSON.stringify(data.where);
			}
			//把排序换成字符串
			if (data.order) {
				var sort = data.order.key + ' ' + data.order.sort;
				if (data.order.key != 'sort') {
					// sort = sort + ",sort asc"; //如果不是综合排序，增加上第二个排序优先级排序
				}
				newData.order = sort;
			} else {
				newData.order = 'sort asc';
			}
			return newData;
		},
		handleParamsData(query) {
			let where = {};
			if (query.key) {
				where = { keyword: query.key };
			}
			if (query.id) {
				where = {
					cat_id: query.id
				};
			}
			if (query.type) {
				if (query.type == 'hot') {
					where = {
						hot: true
					};
				}
				if (query.type == 'recommend') {
					where = {
						recommend: true
					};
				}
			}
			this.setSearchOptions({ where: where });
			this.getGoodsList();
		},
		//点击综合排序
		comprehensive: function () {
			this.setSearchOptions(
				{
					order: {
						key: 'sort',
						sort: 'asc'
					},
					page: 1
				},
				true
			);
			this.getGoodsList();
		},
		//销量排序
		salesVolume: function () {
			let sort = 'asc';
			if (this.searchOptions.order.key == 'watch_num') {
				if (this.searchOptions.order.sort == 'desc') {
					sort = 'asc';
				} else {
					sort = 'desc';
				}
			}
			this.setSearchOptions(
				{
					order: {
						key: 'watch_num',
						sort: sort
					},
					page: 1
				},
				true
			);
			this.getGoodsList();
		},
		//价格排序
		priceSort: function () {
			let sort = 'asc';
			if (this.searchOptions.order.key == 'start_price') {
				if (this.searchOptions.order.sort == 'desc') {
					sort = 'asc';
				} else {
					sort = 'desc';
				}
			}
			this.setSearchOptions(
				{
					order: {
						key: 'start_price',
						sort: sort
					},
					// where: {
					//   cat_id: this.selectedBrandId
					// },
					page: 1
				},
				true
			);
			this.getGoodsList();
		},
		lastPriceSort: function () {
			let sort = 'asc';
			if (this.searchOptions.order.key == 'latest_price') {
				if (this.searchOptions.order.sort == 'desc') {
					sort = 'asc';
				} else {
					sort = 'desc';
				}
			}
			this.setSearchOptions(
				{
					order: {
						key: 'latest_price',
						sort: sort
					},
					page: 1
				},
				true
			);
			this.getGoodsList();
		},

		//获取商品列表
		getGoodsList() {
			let obj = this.conditions();
			//this.loadingShow = true;
			showLoading();
			// obj.order = obj.order.replaceAll('sort asc', 'sort asc')

			this.$api.auctionList(obj).then((res) => {
				if (res.status) {
					this.totalPage = Math.ceil(res.data.count / this.searchOptions.limit);
					this.goodsList = res.data.list;
					this.showFilter = this.goodsList.length > 0 ? true : false;
					if (res.data.list.length == 0) {
						this.noDataIsShow = true;
					} else {
						this.noDataIsShow = false;
					}
					// this.loadingShow = false;
				}
				hideLoading();
			});
		},
		//设置筛选条件
		setSearchOptions: function (searchData, clear = false) {
			var sd = this.searchOptions;
			this.searchOptions = deepCopy(sd, searchData);
			if (clear) {
				this.goodsList = [];
			}
		},
		//分页
		handleCurrentChange(val) {
			this.setSearchOptions({
				page: val
			});
			this.getGoodsList();
		},
		getAllCat() {
			this.$api.categories().then((res) => {
				this.filter = res.data;
				this.syncParentId();
			});
		},
		advert() {
			this.$api.advert({ codes: 'pc_auction_list' }).then((res) => {
				this.advertObj = res.data.list['pc_auction_list'] || [];
			});
		}
	},
	created() {
		let query = this.$route.query;
		this.selectedBrandId = query.id;
		this.handleParamsData(query);
		this.goodsStyle = goodsStyle;

		this.getAllCat();

		this.advert();
	},
	beforeDestroy() {
		if (this.hoverTimer) {
			clearTimeout(this.hoverTimer);
		}
		if (this.enterTimer) {
			clearTimeout(this.enterTimer);
		}
	},
	mounted() {}
};
</script>
<style lang="scss" scoped>
@import '@/assets/css/mixin.scss';
@import '@/assets/css/variable.scss';

.shop-container {
	.nav {
		@include line-height(40px);
		font-size: 12px;
		span {
			padding: 0 3px;
			font-size: #757575;
		}
		a:hover {
			color: #000;
		}
	}
	.nodata {
		height: 40px;
		line-height: 40px;
		margin-bottom: 10px;
		padding-left: 14px;
		font-weight: bold;
		background: #fffdee;
		border: 1px solid #edd28b;
		.search-name {
			color: $theme-color;
		}
	}
	.container {
		background: #fff;
		padding: 4px 18px;
		margin-bottom: 20px;
		.filter-box {
			margin: 0 auto;
			font-size: 14px;
			.filter-list-wrap {
				position: relative;
				padding-left: 72px;
				transition: height 0.25s linear;
				border-bottom: 1px dashed $border;
				&.open {
					.filter-list {
						height: 120px;
					}
				}
				.filter-list-head {
					width: 72px;
					position: absolute;
					left: 0;
					top: 14px;
					color: #b0b0b0;
				}
				.filter-list {
					display: flex;
					flex-flow: row wrap;
					.filter-item {
						width: 85px;
						height: 20px;
						line-height: 20px;
						padding: 12px 0;
						cursor: pointer;
						&.active {
							& > span {
								color: $theme-color;
							}
						}
					}
				}
				.more {
					position: absolute;
					right: 0;
					top: 8px;
					height: 24px;
					line-height: 24px;
					color: #757575;
					cursor: pointer;
					user-select: none;
					&:hover {
						color: $theme-color;
					}
					.icon {
						display: inline-block;
						transition: all 0.2s;
						&.top {
							transform: rotate(180deg);
						}
					}
				}
			}
		}
	}
	.sort-box {
		position: relative;
		padding-left: 72px;
		.sort-title {
			position: absolute;
			top: 0;
			left: 0;
			height: 45px;
			line-height: 45px;
			color: #b0b0b0;
		}
	}
	.filter-nav {
		height: 45px;
		display: flex;
		align-items: center;
		li {
			padding: 0 30px;
			font-size: 14px;
			border-right: 1px solid $border;
			&:last-of-type {
				border: none;
			}
			&:hover {
				color: $theme-color;
				.icon {
					color: $theme-color;
				}
			}
			a {
				display: block;
			}
			&.active {
				color: $theme-color;
				.icon {
					color: $theme-color;
				}
			}
			&:first-of-type {
				padding-left: 0;
				padding-right: 30px;
			}
			.icon {
				color: #333;
				font-size: 14px;
			}
		}
		.sort-title {
			margin-right: 40px;
		}
	}
	.filter-checkbox {
		height: 45px;
		line-height: 45px;
		position: relative;
		padding-left: 72px;
		border-top: 1px dashed $border;
		span {
			position: absolute;
			left: 0;
			top: 0;
			color: #b0b0b0;
		}
	}
}

.child-content {
	position: absolute;
	top: 100%;
	left: -18px;
	width: 1226px;
	background: #fafafa;
	padding-left: 72px;
	box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
	box-sizing: border-box;
	z-index: 100;
	border-top: 1px solid #f0f0f0;

	/* 离开间隙防护垫片，防止鼠标移动到二级分类时丢失焦点 */
	&::before {
		content: '';
		position: absolute;
		top: -10px;
		left: 0;
		right: 0;
		height: 10px;
	}

	.span-wrap {
		width: 100%;
		min-height: 44px;
		display: flex;
		flex-wrap: wrap;
		align-items: center;
		padding: 6px 0;

		span {
			margin-right: 24px;
			cursor: pointer;
			font-size: 13px;
			color: #666;
			line-height: 28px;
			transition: color 0.2s;

			&:hover {
				color: $theme-color;
			}

			&.active {
				color: $theme-color;
				font-weight: bold;
			}
		}
	}
}

.fade-enter-active {
	transition: opacity 0.2s ease;
}
.fade-leave-active {
	transition: opacity 0.3s ease;
}
.fade-enter,
.fade-leave-to {
	opacity: 0;
}
</style>
